import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {Button, Confirm, Label} from 'semantic-ui-react';

const Index = ({ content, buttonProps, labelProps, header, confirmFunction }) => {
	const [open, setOpen] = useState(false);

	const closeModal = e => {
		if (e) {
			e.stopPropagation();
		}
		setOpen(false);
	};

	const openModal = e => {
		if (e) {
			e.stopPropagation();
		}
		setOpen(true);
	};

	const handleConfirm = e => {
		e.stopPropagation();
		confirmFunction();
		closeModal();
	};

	return (
		<>
			{buttonProps ? (
				<Button {...buttonProps} type="button" onClick={openModal}>
					{buttonProps.value || null}
				</Button>
			) : (
				<Label {...labelProps} onClick={openModal} />
			)}
			<Confirm
				open={open}
				header={header}
				onCancel={closeModal}
				onConfirm={handleConfirm}
				content={content}
			/>
		</>
	);
};

Index.propTypes = {
	buttonProps: PropTypes.shape({
		value: PropTypes.string,
		positive: PropTypes.bool,
		negative: PropTypes.bool,
		buttonStyle: PropTypes.object
	}),
	labelProps: PropTypes.shape({}),
	content: PropTypes.string.isRequired,
	header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
	confirmFunction: PropTypes.func.isRequired
};

Index.defaultProps = {
	buttonProps: undefined,
	labelProps: undefined
};

export default Index;
